'use strict';

var Modal = require('./modal');

$('body').on('click tap', '.js-modal-info', function (e) {
  e.preventDefault();
  var $this = $(this);
  var title = $this.find('.service-description').text();
  var data = $this.data();
  if (data.file) {
    Modal.open({
      title: title,
      body: '<div class="lazyload" data-include="/api/htmls/modal/' + data.file + '"></div>',
      windowTopClass: data.topClass || 'modal-centered'
    });
  }
});
